<template>
    <div class="table-container" style="width:80%;max-height:345px;">
        <table>
            <thead>
            <tr>
                <th colspan="4" style="text-align:left;">accounts</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="accounts.length === 0">
                <tr style="font-weight:bold;">
                    <td colspan="4" style="text-align:center;">
                        <span>no accounts assigned</span>
                    </td>
                </tr>
            </template>
            <tr v-for="account in accounts" :key="account.id"
                style="border:none;background:lemonchiffon;">
                <td style="width:70%;">
                    <div style="text-align:left;font-weight:bold;">
                        <sup>[{{ account.id }}]</sup> {{ account.contact.name }}
                    </div>
                    <div class="product-banner">
                        {{ account.deliveryType }} | deck: {{ account.priceDeck }}
                    </div>
                </td>
                <td class="control-icon-style">
                    <tooltip-information text="products"
                                         type="point-down">
                        <font-awesome-icon icon="clipboard-list"
                                           v-on:click="openProductList(account)"/>
                    </tooltip-information>
                </td>
                <td class="control-icon-style">
                    <tooltip-information text="orders"
                                         type="point-down">
                        <font-awesome-icon icon="file-invoice-dollar"
                                           v-on:click="openOrderList(account)"/>
                    </tooltip-information>
                </td>
                <td class="control-icon-style">
                    <tooltip-information text="users"
                                         type="point-down">
                        <font-awesome-icon icon="users"
                                           v-on:click="openUserList(account)"/>
                    </tooltip-information>
                </td>
            </tr>
            </tbody>
        </table>

        <product-list v-if="displayProducts"
                      :dairy-id="participant.dairy.id"
                      :dairy-name="participant.dairyName"
                      :customer-id="selectedAccount.id"
                      :customer-name="selectedAccount.contact.name"
                      :price-deck="selectedAccount.priceDeck"
                      @apierror="setApiError"
                      @apierrortext="setApiErrorText"
                      @close="displayProducts=false"></product-list>
        <order-list v-if="displayOrders"
                    :account="accountToPass"
                    :username="username"
                    :role="role"
                    @apierror="setApiError"
                    @apierrortext="setApiErrorText"
                    @close="displayOrders=false"></order-list>
        <user v-if="displayUsers"
              :dairy="participant.dairy"
              :account="selectedAccount"
              @apierror="setApiError"
              @apierrortext="setApiErrorText"
              @close="displayUsers=false"></user>
    </div>
</template>

<script>
import TooltipInformation from '@/components/tooltip/TooltipInformation'
import ProductList from '@/components/ordering/products/List'
import OrderList from '@/components/ordering/List'
import User from '@/components/control/dairy/account/user/User'

export default {
    name: 'Account',
    props: ['username', 'role', 'participant'],
    emits: ['apierror', 'apierrortext'],
    data: function () {
        return {
            accounts: [],
            selectedAccount: {},
            accountToPass: {},
            displayProducts: false,
            displayOrders: false,
            displayUsers: false,
        }
    },
    components: {
        TooltipInformation,
        ProductList,
        OrderList,
        User,
    },
    methods: {
        list() {
            this.axios
                .get("control/dairy/accounts", {
                    params: {
                        dairyId: this.participant.dairy.id,
                    }
                })
                .then(response => {
                    this.accounts = _.orderBy(response.data, ['contact.name', 'id'], ['asc', 'asc'])
                })
                .catch(error => {
                    this.setApiError(true)
                    this.setApiErrorText(error.response.statusText)
                })
        },
        openProductList: function (account) {
            this.selectedAccount = account
            this.displayProducts = true
        },
        openOrderList: function (account) {
            this.selectedAccount = account

            this.accountToPass = {
                'customerId': this.selectedAccount.id,
                'customerName': this.selectedAccount.contact.name,
                'dairyId': this.participant.dairy.id,
                'dairyName': this.participant.dairy.name,
                'deliveryType': this.selectedAccount.deliveryType,
                'mandatoryPO': this.selectedAccount.mandatoryPO,
                'orderDatePricing': this.selectedAccount.orderDatePricing,
                'priceDeck': this.selectedAccount.priceDeck
            }

            this.displayOrders = true
        },
        openUserList: function (account) {
            this.selectedAccount = account
            this.displayUsers = true
        },
        setApiError: function (isError) {
            this.$emit('apierror', isError)
        },
        setApiErrorText: function (text) {
            this.$emit('apierrortext', text)
        },
    },
    created() {
        this.list()
    },
}
</script>
